<div id="header">
  <div class="header-text">
    <h1>{{ headerTitle }}</h1>
    <p *ngIf="subTitle">{{ subTitle }}</p>
  </div>
</div>
